<template>
  <div class="home-container">
    <div class="home-content" v-if="recordFlag">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="ind" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="img" label="活动图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.img" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="活动名称" align="center">
        </el-table-column>
        <el-table-column prop="activityTime" label="活动时间" align="center">
        </el-table-column>     
        <el-table-column prop="signUpStartTime" label="报名时间" align="center">
        </el-table-column>     
        <el-table-column prop="restrictNumber" label="限制报名人数" align="center">
        </el-table-column> 
        <el-table-column prop="status" label="活动状态" align="center" :formatter="activityStatus">
        </el-table-column>      
        <el-table-column  label="活动记录" align="center">
          <template slot-scope="scope">
            <a  @click="bindRecord(scope.row.id)">活动记录</a>
          </template>
        </el-table-column>                                
        <!-- <el-table-column prop="isRecommend" label="是否推荐" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isRecommend"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>         -->
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="活动图片" prop="img">
                <upload
                  :url.sync="addData.img"
                  :src="addData.img"
                  type="img"
                  :width="220"
                  :height="160"
                ></upload>
                <div style="color: red">*(建议尺寸220px * 160px)）</div>
              </el-form-item>
            </el-col>
          </el-row>    
           <el-row>
            <el-col :span="12">
              <el-form-item label="活动名称" prop="title">
                <el-input placeholder="请输入活动名称" v-model="addData.title"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="限制报名人数" prop="restrictNumber" label-width="120px">
                <el-input-number v-model="addData.restrictNumber"   label="限制报名人数"></el-input-number>
                <!-- <el-input placeholder="限制报名人数" v-model="addData.restrictNumber"></el-input> -->
              </el-form-item>
            </el-col>   
          </el-row>  
           <el-row>
            <el-col :span="24">
              <el-form-item label="活动时间" prop="activityTime">
                <el-date-picker
                    v-model="addData.activityTime"
                    type="datetimerange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>    
           <el-row>
            <el-col :span="24">
              <el-form-item label="报名时间" prop="signUpTime">
                <el-date-picker
                    v-model="addData.signUpTime"
                    type="datetimerange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>                   
           <el-row>
            <el-col :span="24">
            <el-form-item label="活动内容" prop="content">
              <ueditor v-model="addData.content"></ueditor>
            </el-form-item>  
            </el-col>
          </el-row>            
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div v-else>
      <volunteerRecord :activityId="activityId" @back="back"></volunteerRecord>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
import ueditor from "../../components/ueditor"
import volunteerRecord from './components/volunteerRecord.vue'
import reg from '../../utils/reg';
export default {
  components: {
    upload,
    ueditor,
    volunteerRecord
  },
  data() {
    return {
      searchForm: {
        site: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        img: "",
        activityTime: "",
        content: "",
        endTime: "",
        isRecommend: "",
        restrictNumber: "",
        signUpEndTime: "",
        signUpNumber: "",
        signUpStartTime: "",
        signUpTime: "",
        startTime: "",
        title: "",
        type:1
      },
      addDataRules: {
        img: [{ required: true, message: "请上传活动图片", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        restrictNumber: [{ required: true, message: "请输入限制报名人数", trigger: "blur" }],
        activityTime: [{ required: true, message: "请选择活动时间", trigger: "blur" }],
        signUpTime: [{ required: true, message: "请选择报名时间", trigger: "blur" }],
        content: [{ required: true, message: "请输入活动内容", trigger: "blur" }],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },      
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      activityId:'',
      recordFlag:true
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    back(){
      this.recordFlag = true
    },
    activityStatus(row){
      if(row.status == 1){
        return "未开始"
      }else if(row.status == 2){
        return "进行中"
      }else if(row.status == 3){
        return "已结束"
      }
    },
    // 活动记录
    bindRecord(row){
      this.activityId = row
      this.recordFlag = false
    },    
    // 修改状态
    updataStatus(row) {
      let data = {
        id:row.id,
        isRecommend:row.isRecommend ? 1 : -1
      }
      this.$Apis.activityRecommend(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },    
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.addData.activityTime = this.addData.activityTime.split('-')
      this.addData.signUpTime = this.addData.signUpTime.split('-')
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.activityDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.addData.startTime = reg.filterTime(this.addData.activityTime[0])
          this.addData.endTime = reg.filterTime(this.addData.activityTime[1])
          this.addData.signUpStartTime = reg.filterTime(this.addData.signUpTime[0])
          this.addData.signUpEndTime = reg.filterTime(this.addData.signUpTime[1])
          var data = {
            id: this.addData.id || "",
            img: this.addData.img,
            title: this.addData.title,
            restrictNumber: this.addData.restrictNumber,
            startTime: this.addData.startTime,
            endTime: this.addData.endTime,
            signUpStartTime: this.addData.signUpStartTime,
            signUpEndTime: this.addData.signUpEndTime,
            content: this.addData.content,
            type: 2,
          };
          this.$Apis.activityAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad()
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        type:2
      };
      this.$Apis.activityList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item,ind) => {
            item.isRecommend = item.isRecommend == 1 ? true : false;
            item.ind = ind + 1
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>